import React from 'react';
import { Switch as AntSwitch } from 'antd-v5';

export interface SwitchProps {
  checked?: boolean;
  onChange?: (x: boolean) => void;
  size?: 'small' | 'default';
  disabled?: boolean;
  'data-cy'?: string;
  className?: string;
}

export const Switch = ({ checked, onChange, size, disabled, 'data-cy': dataCy, className }: SwitchProps) => {
  return (
    <AntSwitch
      checked={checked}
      onChange={onChange}
      size={size}
      disabled={disabled}
      data-cy={dataCy}
      className={className}
    />
  );
};
